import React, { useEffect, useState } from 'react';
import { Box, IconButton, Popover, Typography, Badge } from '@mui/material';
import { useSelector } from 'react-redux';
import { Bell } from '@phosphor-icons/react';
import { useLocation, useNavigate  } from 'react-router-dom';
import httpClient from '../../_util/api';
import './style.scss';

const Notifications = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [noOfUnReadNotifications, setNoOfUnReadNotifications] = useState(0);

  const agentCode = localStorage.getItem('agentCode');

  const userdetail = useSelector((state) => state.mainSlice.userdetail);
  
  const { role } = userdetail;

  const location = useLocation();
  const navigate = useNavigate();

  const handleIconClick = (event) => {
    setAnchorEl(event.currentTarget);
    fetchNotifications();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

    const handleRemoveNotificationHandler = async (notificationId) => {
    try {
      const res = await httpClient.put(`/notifications/updateNotification/${notificationId}`);
      if (res.status === 200) {
        setNotifications((prev) =>
          prev.filter((n) => n.id !== notificationId)
        );
      }
    } catch (error) {
      console.error('Error updating notification:', error);
    }
  };

  const handleRedirectNotificationHandler = () => {
    if(role == "finance") {
      if (!location.pathname.endsWith('/partner-payment')) {
        navigate(`${location.pathname}/partner-payment`);
      }
    } else {
      if (!location.pathname.endsWith('/application')) {
        navigate(`${location.pathname}/application`);
      }
    }
  };

  const fetchNotifications = async () => {
    let url = '';

    if (role === 'vendor') {
      url = '/notifications/getAllNotificationVendor';
    } else if (role === 'reviewer' || role === 'approver') {
      url = '/notifications/getAllNotificationViewer';
    } else if (role === 'student') {
      url = '/notifications/getAllStudentNotification';
    } else if (role === 'finance') {
      url = '/notifications/getAllFinanceNotification';
    } else {
      url = `/notifications/getAllNotification_VendorView/${agentCode}`;
    }

    try {
      const res = await httpClient.get(url);
      if (res?.status === 200) {
        setNotifications(res?.data.notifications);
        setNoOfUnReadNotifications(res?.data?.notifications?.length);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const open = Boolean(anchorEl);

  const id = open ? 'notification-popover' : undefined;

  return (
    <Box position="relative">
      <IconButton onClick={handleIconClick} aria-describedby={id}>
        <Badge
          badgeContent={noOfUnReadNotifications}
          color="error"
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '10px',
              height: '18px',
              minWidth: '18px',
              backgroundColor: '#f44336',
            },
          }}
        >
          <Bell size={24} weight={open ? 'fill' : 'regular'} color={'#404040'} />
        </Badge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1,
            width: 320,
            maxHeight: 400,
            overflowY: 'auto',
            p: 2,
            borderRadius: 2,
            boxShadow: 3,
          },
        }}
      >
        {notifications.length > 0 ? (
          [...notifications].reverse().map((item, index) => (
          <Box
            key={index}
            sx={{
              p: 1.5,
              mb: 1,
              borderRadius: 2,
              backgroundColor: '#4caf50',
              color: '#fff',
              transition: '0.3s',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: "12px",
            }}
          >
            <Typography onClick={() => handleRedirectNotificationHandler(item.id)} sx={{ cursor: 'pointer' }} fontSize={14}>{item.message}</Typography>
            <Typography onClick={() => handleRemoveNotificationHandler(item.id)} sx={{ cursor: 'pointer' }} fontSize={14} fontWeight="bold">X</Typography>
          </Box>
          ))
        ) : (
          <Typography variant="body2" color="textSecondary" textAlign="center">
            No new notifications.
          </Typography>
        )}
      </Popover>
    </Box>
  );
};

export default Notifications;
